import CommonQuantityInput from './CommonQuantityInput';

export default CommonQuantityInput;
